import React from 'react';
import { motion } from 'framer-motion';
import './AboutSection.css';

const AboutSection = () => {
  return (
    <section className="about">
      <div className="container">
        <motion.div 
          className="about-content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="about-text">
            <motion.h2 
              className="about-title"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              Who We Are
            </motion.h2>
            
            <motion.p 
              className="about-subtitle"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
            >
              Crafting authentic adventures since day one
            </motion.p>
            
            <motion.div 
              className="about-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              viewport={{ once: true }}
            >
              <h3>What We Are:</h3>
              <p><strong>NomadTrailz - Nomads of the Earth</strong></p>
              <p>
                At NomadTrailz, we specialize in crafting authentic, offbeat travel experiences. 
                Our journeys are designed to connect curious explorers with untouched destinations, 
                rich local cultures, and the raw beauty of nature.
              </p>
            </motion.div>
            
            <motion.div 
              className="about-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.8 }}
              viewport={{ once: true }}
            >
              <h3>Why Choose Us:</h3>
              <ul>
                <li>Custom-designed adventures for solo travelers, groups, and thrill-seekers</li>
                <li>Handpicked itineraries that go beyond the ordinary</li>
                <li>A vibrant community of passionate travelers</li>
                <li>Personalized support and attention at every step</li>
              </ul>
            </motion.div>
            
            <motion.div 
              className="about-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 1 }}
              viewport={{ once: true }}
            >
              <h3>Connect With Us:</h3>
              <p>
                We offer 24/7 customer support to ensure you're never alone on your journey. 
                At NomadTrailz, your experience is our top priority—we're committed to delivering 
                exceptional service and unforgettable adventures.
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;
